import { render, staticRenderFns } from "./PageBasicInfo.vue?vue&type=template&id=26a8cf06&"
import script from "./PageBasicInfo.vue?vue&type=script&lang=js&"
export * from "./PageBasicInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports